import React from "react";
import { Link } from 'gatsby'
import "./styles.scss";

export const FooterTemplate = () => {
  return (
    <nav className="footer">
      <div className="footer-container  container">
        <div>
          <h3>Osnovna šola Ivana Roba</h3>
          <p>
            Andreja Gabrščka 1<br />
            5290 Šempeter pri Gorici
            <br />
            T: +386 (0) 5 / 39 35 211
            <br />
            E: osir.sempeter@gmail.com
            <br />
            E: o-irsempeter.ng@guest.arnes.si
          </p>
        </div>
        <div>
          <h3>Povezave</h3>
          <ul>
            <li>
              <Link to="/hisni-red">Hisni red</Link>
            </li>
            <li>
              <Link to="/prevozi">Prevozi</Link>
            </li>
            <li>
              <Link to="/pogovorne-ure">Pogovorne ure</Link>
            </li>
          </ul>
        </div>
        <div>
          <h3>Donatorstvo</h3>
          <p>
            Veseli bomo vsakega prispevka v kateri koli obliki. V kolikor želite
            pomagati, nam pišite na elektronski naslov in nas kontaktirajte
            preko telefona.
          </p>
        </div>
      </div>
      <div className="bottom">
        <div className="container">
          Osnovna šola Ivana Roba | Vse pravice pridrzane. 2018
        </div>
      </div>
    </nav>
  );
};

const Footer = () => {
  return <FooterTemplate />;
};

export { Footer };
